export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-chord/src/array.js
// module id = nzIU
// module chunks = 0